<template>
  <a-card :bordered="false">
    <div>
      <a-form>
        <search-header :col="3">
          <search-list>
            <a-form-item label="姓名" v-bind="searchItemLayout">
              <a-input v-model="queryParams.contactsInfo" placeholder="请输入商品名称"></a-input>
            </a-form-item>
            <a-form-item label="手机号" v-bind="searchItemLayout">
              <a-input v-model="queryParams.merchantMobile" placeholder="请输入商品名称"></a-input>
            </a-form-item>
            <a-form-item label="店铺名称" v-bind="searchItemLayout">
              <a-input v-model="queryParams.shopName" placeholder="请输入店铺名称"></a-input>
            </a-form-item>
            <a-form-item label="状态" v-bind="searchItemLayout">
              <a-select v-model="queryParams.drawCashStatus" :allowClear="true" placeholder="请选择"
                        style="min-width:140px;">
                <a-select-option value>全部</a-select-option>
                <a-select-option :value="0">申请中</a-select-option>
                <a-select-option :value="1">通过审核</a-select-option>
                <a-select-option :value="2">拒绝提现</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="申请时间" v-bind="searchItemLayout">
              <a-range-picker format="YYYY-MM-DD" @change="onChange" style="width:100%;"></a-range-picker>
            </a-form-item>
            <a-form-item style="margin-left:2%;">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button @click="exportantData">导出</a-button>
              <a-button @click="depositSet">提现设置</a-button>
            </a-form-item>
          </search-list>
        </search-header>
      </a-form>
      <custom-page-table
        ref="table"
        :queryParams="queryParams"
        :columns="columns"
        :requestPromise="loadPromise"
      >
        <span slot="merchantType" slot-scope="rowItem">
          {{ rowItem.text | merchantTypeName }}
        </span>
        <span slot="drawCashStatus" slot-scope="rowItem">
          {{ rowItem.text | drawCashStatusName }}
        </span>
        <span slot="action" slot-scope="rowItem">
          <a
            v-if="rowItem.record.drawCashStatus == 0"
            @click="handleClick(rowItem.record.drawCashId, 1, rowItem.record.merchantId)"
          >审核通过</a
          >
          <a
            v-if="rowItem.record.drawCashStatus == 0"
            style="color:red;margin:0 15px;"
            @click="handleClick(rowItem.record.drawCashId, 2, rowItem.record.merchantId)"
          >拒绝提现</a
          >
          <a
            v-if="rowItem.record.drawCashStatus != 0"
            @click="handleClick(rowItem.record.drawCashId, 3, rowItem.record.merchantId)"
          >提现详情</a
          >
        </span>
      </custom-page-table>
    </div>
    <a-modal title="提现方式设置" :width="600" :footer="null" :visible="settingVisible" @cancel="handleSettingCancel">
      <a-form-model :model="ruleForm" ref="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="支付手续费承担方">
          <a-radio-group v-model="ruleForm.payHandlingFeesUndertake">
            <a-radio :value="1">运营商</a-radio>
            <a-radio :value="2">分销员</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="支付费率" v-if="ruleForm.payHandlingFeesUndertake==2" prop="payHandlingFeesRatio">
          <a-input v-model="ruleForm.payHandlingFeesRatio" placeholder="0.01-10" addon-after="%"
                   style="max-width: 215px;"/>
          <div class="line-font">
            设置后，当分销员自主销售商品产生佣金收入时，将扣除一笔销售额对应的支付手续费。最大扣除支付手续费需≤实收佣金
          </div>
        </a-form-model-item>
        <a-form-model-item label="默认提现方式">
          <a-radio-group v-model="ruleForm.withdrawDeposit">
            <a-radio :value="1">支付宝</a-radio>
            <a-radio :value="2">微信</a-radio>
            <a-radio :value="3">银行卡</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <div v-if="ruleForm&&ruleForm.withdrawDeposit==2">
          <a-form-model-item label="单笔最大金额" prop="singleMaxAmount">
            <a-input v-model="ruleForm.singleMaxAmount" placeholder="请输入单笔最大金额" addon-after="元"
                     style="max-width: 215px;"/>
          </a-form-model-item>
          <a-form-model-item label="单日最大金额" prop="dayMaxAmount">
            <a-input v-model="ruleForm.dayMaxAmount" placeholder="请输入单日最大金额" addon-after="元"
                     style="max-width: 215px;"/>
          </a-form-model-item>
        </div>
        <a-form-model-item :wrapper-col="{offset:7}">
          <a-button type="primary" @click="submitForm" :loading="submitLoading">保存设置</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal :title="drawTitle" :width="700" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-form-model ref="form" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" class="withdraw-form">
        <a-form-model-item label="银行账号" v-if="form.myBankCardNo && getTransferType(form.transferType)">
          <div class="grid-content">{{ form.myBankCardNo }}</div>
        </a-form-model-item>
        <a-form-model-item label="账户名" v-if="form.myBanKName && getTransferType(form.transferType)">
          <div class="grid-content">{{ form.myBanKName }}</div>
        </a-form-model-item>
        <a-form-model-item label="开户银行" v-if="form.myBankBankName && getTransferType(form.transferType)">
          <div class="grid-content">{{ form.myBankBankName }}</div>
        </a-form-model-item>
        <a-form-model-item label="支行名称" v-if="form.myBanKBranch && getTransferType(form.transferType)">
          <div class="grid-content">{{ form.myBanKBranch }}</div>
        </a-form-model-item>
        <a-form-model-item label="所在地区" v-if="form.bankLocation && getTransferType(form.transferType)">
          <div class="grid-content">{{ form.bankLocation }}</div>
        </a-form-model-item>
        <a-form-model-item label="支付宝账号" v-if="form.aliPayAccount && form.transferType == 1">
          <div class="grid-content">{{ form.aliPayAccount }}</div>
        </a-form-model-item>
        <a-form-model-item label="联系人">
          <div class="grid-content">{{ form.merchantContact }}</div>
        </a-form-model-item>
        <a-form-model-item label="联系电话">
          <div class="grid-content">{{ form.merchantMobile }}</div>
        </a-form-model-item>
        <a-form-model-item label="申请时间">
          <div class="grid-content">{{ form.drawCashCreateTime }}</div>
        </a-form-model-item>
        <a-form-model-item label="订单收入区间" v-if="form.drawCashTimeSection">
          <div class="grid-content">{{ form.drawCashTimeSection }}</div>
        </a-form-model-item>
        <a-form-model-item label="申请提现">
          <div class="grid-content">
            <span class="colorrmb">￥{{ form.drawCashAmount }}</span>
          </div>
        </a-form-model-item>
        <a-form-model-item label="实付金额" v-if="form.drawCashStatus == 0">
          <div class="grid-content">
            <a-input v-model="form.payAmount" placeholder="请输入实付金额"></a-input>
          </div>
          <span>用于扣除支付手续费、平台服务费等</span>
        </a-form-model-item>
        <a-form-model-item label="支付方式" v-if="form.drawCashStatus!=2&&status!=2">
          <div class="grid-content">
            <template v-if="form.drawCashStatus == 0">
              <a-radio-group v-model="form.transferType">
                <a-radio :value="3">银行转账</a-radio>
                <a-radio v-if="form.canWxTransfer == 2 && form.drawFailFlag != 1" :value="2">微信转账到零钱</a-radio>
              </a-radio-group>
            </template>
            <template v-else>
              <div v-if="form.transferType == 3">银行转账</div>
              <div v-if="form.transferType == 2">微信转账到零钱</div>
              <div v-if="form.transferType == 1">支付宝转账</div>
              <div v-if="form.transferType == 4">工行在线转账</div>
              <div v-if="form.transferType == 5">工行虚拟户转账</div>
            </template>
          </div>
        </a-form-model-item>
        <a-form-model-item v-if="status == 1 && getIsShow(form.transferType)" label="流水单号">
          <a-textarea :rows="4" placeholder="请填写流水单号" v-model="form.flowNumber" :maxLength="100"></a-textarea>
        </a-form-model-item>
        <a-form-model-item v-if="status == 2" label="拒绝原因">
          <a-textarea
            :rows="4"
            placeholder="请填写拒绝提现的原因"
            v-model="form.drawCashNoPassCause"
            :maxLength="140"
          ></a-textarea>
        </a-form-model-item>
        <a-form-model-item v-if="status == 1 && form.transferType == 4" label="温馨提示">
          <div>确认将通过工商银行发起自动转账操作，提现账户仅支持银行账户；</div>
        </a-form-model-item>
        <a-form-model-item v-if="status == 1 && form.transferType == 5" label="温馨提示">
          <div>
            确认将通过工商银行发起自动转账操作，资金将首先转入平台虚拟账户、再转入提现商户的虚拟账户、最后提现至其绑定银行账户；
          </div>
        </a-form-model-item>
        <a-form-model-item v-if="status == 3" label="提现结果">
          <div class="grid-content">
            <span>{{ form.drawCashStatus | drawCashStatusName }}</span>
          </div>
        </a-form-model-item>
        <a-form-model-item v-if="status == 3" label="备注">
          <div class="grid-content">
            <span>{{ form.flowNumber }}{{ form.drawCashRemark }}{{ form.drawCashNoPassCause }}</span>
          </div>
        </a-form-model-item>
        <hr class="layui-bg-green"/>
        <a-form-model-item label="账户余额">
          <div class="grid-content">￥{{ form.accountTotal }}</div>
        </a-form-model-item>
        <a-form-model-item label="可提现金额">
          <div class="grid-content">￥{{ form.accountAbleDrawCash }}</div>
        </a-form-model-item>
        <a-form-model-item label="商户名称">
          <div class="grid-content">{{ form.merchantName }}</div>
        </a-form-model-item>
        <a-form-model-item label="商户类型">
          <div class="grid-content">
            <span v-if="form.merchantType == 1">运营商</span>
            <span v-else>二级分销商</span>
          </div>
        </a-form-model-item>
        <a-form-model-item label="微信付款单号" v-if="form.drawCashThirdTradeNo">
          <div class="grid-content">{{ form.drawCashThirdTradeNo }}</div>
        </a-form-model-item>
        <span v-if="status != 3" class="dialog-footer">
          <a-popconfirm
            :title="status == 1 ? '此操作将通过审核, 是否继续?' : '此操作将拒绝提现, 是否继续?'"
            @confirm="confirmSubmint"
          >
            <a-button type="primary">确认操作</a-button>
          </a-popconfirm>
          <a-button style="margin-left:20px;" @click="visible = false">取 消</a-button>
        </span>
        <span v-else class="dialog-footer1">
          <a-button type="danger" @click="visible = false">关闭</a-button>
        </span>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import searchForm from '@/utils/mixins/searchFormMixins'

export default {
  name: 'WithdrawList',
  mixins: [searchForm],
  data() {
    let validateRatio = (rule, value, callback) => {
      if (!Number(value)) {
        callback(new Error('请输入数字'))
      } else {
        if (!(0.01 <= Number(value) && Number(value) <= 10)) {
          callback(new Error('请输入0.01-10以内的数字'))
        } else {
          callback()
        }
      }
    }
    let validateDayMaxAmount = (rule, value, callback) => {
      if (Number(value) < this.ruleForm.singleMaxAmount) {
        callback(new Error('需大于单笔最大金额'))
      } else {
        callback()
      }
    }
    return {
      columns: [
        {
          title: '申请时间',
          dataIndex: 'drawCashCreateTime'
        },
        {
          title: '店铺名称',
          dataIndex: 'shopName'
        },
        {
          title: '姓名',
          dataIndex: 'contactsInfo'
        },
        {
          title: '电话',
          dataIndex: 'merchantMobile'
        },
        {
          title: '本次余额(元)',
          dataIndex: 'accountTotal'
        },
        {
          title: '本次可提现(元)',
          dataIndex: 'accountAbleDrawCash'
        },
        {
          title: '申请提现(元)',
          dataIndex: 'drawCashAmount'
        },
        {
          title: '状态',
          dataIndex: 'drawCashStatus',
          scopedSlots: { customRender: 'drawCashStatus' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      loadPromise: params => this.getListPromise(params),
      currentFormLayout: {
        labelCol: {
          xxl: { span: 4 },
          xl: { span: 5 },
          lg: { span: 5 },
          sm: { span: 7 },
          md: { span: 10 },
          xs: { span: 12 }
        },
        wrapperCol: {
          xxl: { span: 17 }, //≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 16 }, //≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 14 }, //≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 14 }, //≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 11 }, //≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 11 } //xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        },
        offsetCol: {
          xxl: { span: 4 },
          xl: { span: 5 },
          lg: { span: 5 },
          sm: { span: 7 },
          md: { span: 10 },
          xs: { span: 12 }
        }
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      rules: {
        payHandlingFeesRatio: [
          { required: true, message: '请输入支付费率', trigger: 'blur' },
          { validator: validateRatio, trigger: 'blur' }
        ],
        singleMaxAmount: [
          { required: true, message: '请输入单笔最大金额', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额',
            trigger: 'blur'
          }
        ],
        dayMaxAmount: [
          { required: true, message: '请输入单日最大金额', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额',
            trigger: 'blur'
          },
          { validator: validateDayMaxAmount, trigger: 'blur' }
        ]
      },
      form: {
        accountAbleDrawCash: '', // 商家可提现金额 ,
        accountTotal: '', // 商家账户金额 ,
        bankLocation: '', //银行所在地 ,
        drawCashAmount: '', // 申请提现金额 ,
        drawCashCreateTime: '', //申请时间 ,
        drawCashNoPassCause: '', //不通过原因 ,
        drawCashStatus: '', //审核状态 ,
        flowNumber: '', //流水单号 ,
        merchantType: '', //商户类型 1运营商 2二级分销商 ,
        merchantContact: '', //联系人 ,
        merchantId: '', //商户ID ,
        merchantMobile: '', //联系电话 ,
        merchantName: '', //商户名称 ,
        myBanKBranch: '', //支行名 ,
        myBanKName: '', //开户人姓名 ,
        myBankBankName: '', //银行名 ,
        myBankCardNo: '', //银行卡号
        payAmount: '',
        drawCashRemark: ''
      },
      drawCashId: '', //提现ID
      status: '', //审核状态 1 审核通过  2 审核不通过
      visible: false,
      queryParams: {
        contactsInfo: '',
        merchantName: '', //商品名称
        drawCashStatus: '', //商品审核状态
        merchantMobile: '',
        endDate: '', //上架时间结束
        beginDate: '', //上架时间开始
        shopName: ''
      },
      ruleForm: {
        withdrawDeposit: 0,
        payHandlingFeesUndertake: 1,
        payHandlingFeesRatio: undefined,
        singleMaxAmount: '',
        dayMaxAmount: ''
      },
      drawTitle: '',
      settingVisible: false,
      submitLoading: false
    }
  },
  mounted() {

  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getOrderService().post('distributionWithdrawal/selectList', params)
    },
    onChange(dates, dateStrArr) {
      this.queryParams.beginDate = dateStrArr[0]
      this.queryParams.endDate = dateStrArr[1]
    },
    //验证金额
    checkForm() {
      if (this.status == 1) {
        if (this.form.payAmount <= 0) {
          this.$message.error('请输入实付金额')
          return false
        }
        if (this.form.payAmount > 0) {
          if (this.form.payAmount > this.form.drawCashAmount) {
            this.$message.error('必须小于申请提现金额')
            return false
          }

          if (!/^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/.test(this.form.payAmount)) {
            this.$message.error('请输入正确金额')
            return false
          }
        }
      }
      return true
    },
    //点击提交
    confirmSubmint() {
      if (this.checkForm()) {
        this.getThrough()
      }
    },
    //操作接口
    getThrough() {
      this.getHttpServices()
        .getOrderService()
        .post('highestWith/merchantWithdrawAudit', {
          drawCashFlowNumber: this.form.flowNumber,
          drawCashId: this.drawCashId,
          drawCashNoPassCause: this.form.drawCashNoPassCause,
          status: this.status,
          transferType: this.form.transferType,
          payAmount: this.form.payAmount
        })
        .then(res => {
          this.visible = false
          this.$message.success('操作成功')
          this.$refs.table.refresh(true)
        }).catch(err => {
        this.getLogUtils().logWithTag('==操作失败getThrough==', err)
        if (err.status == 1000) {
          this.$message.error(err.msg)
          this.getDetailData(this.drawCashId)
        } else {
          this.visible = false
          if (err.data) {
            this.$message.error(err.data)
          } else {
            this.$message.error(err.msg)
          }
        }
      })
    },
    //保存
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.updateWithdrawDepositSetting()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    //更新提现设置
    updateWithdrawDepositSetting() {
      this.submitLoading = true
      let params = {
        withdrawDeposit: this.ruleForm.withdrawDeposit,
        payHandlingFeesUndertake: this.ruleForm.payHandlingFeesUndertake
      }
      if (this.ruleForm.payHandlingFeesUndertake === 2) {
        params.payHandlingFeesRatio = this.ruleForm.payHandlingFeesRatio
      }
      if (this.ruleForm.withdrawDeposit === 2) {
        params.singleMaxAmount = this.ruleForm.singleMaxAmount
        params.dayMaxAmount = this.ruleForm.dayMaxAmount
      }
      this.getHttpServices().getUserService().post('merchant/connection/save/WithdrawDeposit', params).then(res => {
        this.$message.success('提现方式设置成功')
        this.settingVisible = false
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    //导出
    exportantData() {
      this.queryParams.endDate = this.queryParams.endDate ? this.queryParams.endDate : ''
      this.queryParams.beginDate = this.queryParams.beginDate ? this.queryParams.beginDate : ''
      let url = this.getAppConfig().orderUrl + 'distributionWithdrawal/exportList?merchantId=' + this.$store.getters.userInfo.merchantId + '&account=' + this.$store.getters.userInfo.account + '&merchantType=1&drawCashStatus=' + this.queryParams.drawCashStatus + '&merchantMobile=' + this.queryParams.merchantMobile + '&contactsName=' + this.queryParams.contactsInfo + '&shopName=' + this.queryParams.shopName + '&beginDate=' + this.queryParams.beginDate + '&endDate=' + this.queryParams.endDate
      window.open(url)
    },
    handleCancel() {
      this.visible = false
    },
    handleSettingCancel() {
      this.settingVisible = false
    },
    // 审核通过点击事件
    handleClick(drawCashId, status, merchantId) {
      this.visible = true
      this.drawCashId = drawCashId
      this.status = status
      this.getDetailData(drawCashId)
      if (status == 1) {
        this.drawTitle = '审核通过'
      } else if (status == 2) {
        this.drawTitle = '拒绝提现'
      } else {
        this.drawTitle = '提现详情'
      }
    },
    //获取弹窗详情的接口
    getDetailData(drawCashId) {
      this.getHttpServices()
        .getOrderService()
        .get('highestWith/getWithdrawDetails?drawCashId=' + drawCashId)
        .then(res => {
          this.form = res
          //判断如果this.form.payAmount不存在用申请提现金额
          if (!this.form.payAmount) {
            this.form.payAmount = this.form.drawCashAmount
          }
        })
        .catch(err => {
          this.getLogUtils().logWithTag('错误', err)
        })
    },
    //提现设置
    depositSet() {
      this.settingVisible = true
      this.getWithdrawDepositSetting()
    },
    //获取提现设置信息
    getWithdrawDepositSetting() {
      this.getHttpServices().getUserService().post('merchant/connection/query/WithdrawDeposit').then(res => {
        this.ruleForm = { ...res }
      }).catch(err => {
        this.getLogUtils().logWithTag('错误', err)
      })
    },
    //是否展示
    getTransferType(type) {
      if (type == 3 || type == 4 || type == 5) {
        return true
      } else {
        return false
      }
    },
    getIsShow(type) {
      if (type == 4 || type == 5) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>
<style lang="less" scoped>
.ant-btn + .ant-btn {
  margin-left: 10px;
}

.text-tips {
  height: 40px;
  line-height: 40px;
  color: red;
}

.grid-content {
  line-height: 40px;
}

.colorrmb {
  color: #ff6600;
}

.dialog-footer {
  position: relative;
  left: 74%;
}

.dialog-footer1 {
  position: relative;
  left: 90%;
}

.avatar {
  position: absolute;
  top: 43px;
  left: 2px;
  right: 1px;
  bottom: 1px;
  border-radius: 4px;
  width: 100px;
  height: 100px;
}

.line-font {
  font-size: 15px;
  color: #000c17;
  line-height: 18px;
}
</style>
<style lang="less">
.withdraw-form {
  .ant-form-item {
    margin-bottom: 0 !important;
  }
}
</style>
